import type NumberUnit from '@exodus/currency';
import { useSelector } from 'react-redux';

import createAssetBalanceSelector, {
  balancesLoadedSelector,
} from '@/ui/flux/balances/selectors/asset-balance.js';

type UseBalanceValue = {
  value: NumberUnit | null;
  loading: boolean;
};

const useBalance = (assetName: string): UseBalanceValue => {
  const loaded = useSelector(balancesLoadedSelector);
  const balance = useSelector(createAssetBalanceSelector(assetName));

  return {
    value: balance,
    loading: !loaded,
  };
};

export default useBalance;
